import React, { useState } from "react"
import {
	Modal,
	ModalHeader,
	ModalBody,
	Button,
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane,
} from "reactstrap"
import SwitchButton from "./SwitchButton"
import styles from "./EventButton.module.scss"
import { ModalEventFooter, FollowupTab } from "../../../"
import { useSelector } from "react-redux"
import {
	filterEventsByDelegateType,
	getPenaltyEvents,
} from "../../../../utility/Utils"

function EventButton({ player }) {
	const events = filterEventsByDelegateType()
	const penaltiesOrEnd = useSelector((state) => state.penaltiesOrEnd)
	const allEvents =
		penaltiesOrEnd === "penalties"
			? getPenaltyEvents()
			: [...events.quick, ...events.normal]

	const [isOpen, setIsOpen] = useState(false)
	const [activeTab, setActiveTab] = useState(1)

	const [selectedEvent, setSelectedEvent] = useState({})
	const [followupPlayer, setFollowupPlayer] = useState({})
	const [followupEvent, setFollowupEvent] = useState()

	const removeFollowup = () => {
		if (followupPlayer) setFollowupPlayer({})
		if (followupEvent) setFollowupEvent()
	}

	const dismissModal = () => {
		setIsOpen(false)
		removeFollowup()
		setSelectedEvent({})
		setActiveTab(1)
	}

	const onSelectEvent = (event) => {
		removeFollowup()
		setSelectedEvent(event)
		if (event.followup) {
			setActiveTab(2)
		}
	}

	const createEventBtn = (event, index) => {
		const isSelectedEvent = selectedEvent.name == event.name

		return (
			<Button.Ripple
				key={`eventButton-${index}`}
				color="primary"
				outline={!isSelectedEvent}
				size="lg"
				onClick={() => onSelectEvent(event)}
			>
				{event.name}
			</Button.Ripple>
		)
	}

	return (
		<td>
			<button className={styles.eventButton} onClick={() => setIsOpen(true)}>
				+
			</button>

			<Modal
				isOpen={isOpen}
				toggle={dismissModal}
				className="modal-dialog-centered modal-xl"
			>
				<ModalHeader toggle={dismissModal}>Dodaj event</ModalHeader>
				<Nav tabs>
					<NavItem>
						<NavLink
							active={activeTab === 1}
							onClick={() => setActiveTab(1)}
						>
							Events
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							active={activeTab === 2}
							onClick={() => setActiveTab(2)}
							disabled={!selectedEvent.followup}
						>
							Followup
						</NavLink>
					</NavItem>
				</Nav>
				<ModalBody className={styles.modalBody}>
					<TabContent activeTab={activeTab}>
						<TabPane tabId={1}>
							{penaltiesOrEnd !== "penalties" ? (
								<div className={styles.topPart}>
									{/* The following div is just to properly center the text */}
									<div className="invisible">
										<Button.Ripple color="warning" size="lg">
											Zamjena
										</Button.Ripple>
									</div>
									<h1>
										{player.name} {player.surname}
									</h1>
									<SwitchButton
										player={player}
										dismissModal={dismissModal}
										teamName={player.team}
									/>
								</div>
							) : (
								<div className={styles.topPart}>
									<span></span>
									<h1>
										{player.name} {player.surname}
									</h1>
									<span></span>
								</div>
							)}

							<div className={styles.grid}>
								{allEvents?.map(createEventBtn)}
							</div>
						</TabPane>
						<TabPane tabId={2}>
							<FollowupTab
								followup={selectedEvent.followup}
								selectedPlayer={player}
								setFollowupPlayer={setFollowupPlayer}
								followupPlayer={followupPlayer}
								setFollowupEvent={setFollowupEvent}
								followupEvent={followupEvent}
							/>
						</TabPane>
					</TabContent>
				</ModalBody>
				<ModalEventFooter
					selectedPlayer={player}
					selectedEvent={selectedEvent}
					followupPlayer={followupPlayer}
					followupEvent={followupEvent}
					dismissModal={dismissModal}
				/>
			</Modal>
		</td>
	)
}

export default EventButton
